const BASE_URL = "https://instock-server.fly.dev/";

export default BASE_URL;
